export default __webpack_public_path__ + "static/media/game3_cn.d0ab2534.png";